import { APP_ROUTES } from "../constants";
import { ScanResultPageTabsType } from "../pages/scanresultpage/scanresultpage.types";

export const getScanResultPageUrl = (
  id: string,
  tab: ScanResultPageTabsType
): string => {
  return `${APP_ROUTES.private_routes.source_scan_result}/${id}/${tab}`;
};
